import { render, staticRenderFns } from "./addNewOrder.vue?vue&type=template&id=1ac99883&scoped=true"
import script from "./addNewOrder.vue?vue&type=script&lang=js"
export * from "./addNewOrder.vue?vue&type=script&lang=js"
import style0 from "./addNewOrder.vue?vue&type=style&index=0&id=1ac99883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac99883",
  null
  
)

export default component.exports